import { render, staticRenderFns } from "./fragment-radiobutton-group.vue?vue&type=template&id=cb5eb5b0&scoped=true&"
import script from "./fragment-radiobutton-group.vue?vue&type=script&lang=js&"
export * from "./fragment-radiobutton-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5eb5b0",
  null
  
)

export default component.exports